/**
 * Created by vadim.m on 10/23/2017.
 */
export class EmailRequest {
    public OrderId: number;
    public CustomerId: number;
    public EmailType: number;
    public Comment: string;

    public constructor(init?:Partial<EmailRequest>) {
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./app/objects/email/EmailRequest.ts